module.exports = __webpack_public_path__ + "media/application/images/ui/icon-close-a300c7146b5eea7264f44dadf26f2838.png";